export type FaqAudience = 'company' | 'school';

interface VisibleFaqAudiencesInput {
  isSysadmin: boolean;
  /** Student functions are hidden for this user, so the school FAQ is too. */
  studentsDisabled: boolean;
  hasCompanyAccess: boolean;
  hasSchoolAccess: boolean;
}

/**
 * Company FAQ follows company functions (non-school departments). School FAQ
 * follows school functions. A sysadmin sees every FAQ the portal currently
 * offers, because they are not limited to one organisation's departments.
 */
export const visibleFaqAudiences = ({
  isSysadmin,
  studentsDisabled,
  hasCompanyAccess,
  hasSchoolAccess,
}: VisibleFaqAudiencesInput): FaqAudience[] => {
  const audiences: FaqAudience[] = [];

  if (isSysadmin || hasCompanyAccess) {
    audiences.push('company');
  }

  if (!studentsDisabled && (isSysadmin || hasSchoolAccess)) {
    audiences.push('school');
  }

  return audiences;
};
